var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fork, put, takeLatest, all } from 'redux-saga/effects';
import axios from "axios";
import { INITIALIZE_I18N, setI18nReady } from "../actions/i18n";
import safeSaga from "./utils";
import { addTranslationForLanguage, initialize, setActiveLanguage } from "react-localize-redux";
function getI18nConfig() {
    return axios.get("./i18n/config.json?cb=" + process.env.REACT_APP_CACHEBUSTER).then(function (resp) { return resp.data; });
}
function getLanguageData(language) {
    return axios.get("./i18n/languages/" + language + ".json?cb=" + process.env.REACT_APP_CACHEBUSTER).then(function (resp) { return resp.data; });
}
function onMissingTranslationHandler(missingTranslationOptions) {
    return "_error_: Missing " + missingTranslationOptions.languageCode + " translation";
}
function initializeI18nHandler() {
    var locCfg, defaultLanguage, languages, defaultLanguageData, savedLanguageCode, languageData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, getI18nConfig()];
            case 1:
                locCfg = _a.sent();
                if (!locCfg) return [3, 9];
                defaultLanguage = locCfg.defaultLanguage, languages = locCfg.languages;
                return [4, getLanguageData(defaultLanguage)];
            case 2:
                defaultLanguageData = _a.sent();
                return [4, put(initialize({
                        languages: languages,
                        translation: defaultLanguageData,
                        options: {
                            renderInnerHtml: false,
                            renderToStaticMarkup: false,
                            defaultLanguage: defaultLanguage,
                            onMissingTranslation: onMissingTranslationHandler
                        }
                    }))];
            case 3:
                _a.sent();
                savedLanguageCode = localStorage.getItem('locale');
                if (!savedLanguageCode) return [3, 7];
                return [4, getLanguageData(savedLanguageCode)];
            case 4:
                languageData = _a.sent();
                if (!languageData) return [3, 7];
                return [4, put(addTranslationForLanguage(languageData, savedLanguageCode))];
            case 5:
                _a.sent();
                return [4, put(setActiveLanguage(savedLanguageCode))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4, put(setI18nReady())];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [2];
        }
    });
}
function setActiveLanguageHandler(_a) {
    var languageData;
    var languageCode = _a.payload.languageCode;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4, getLanguageData(languageCode)];
            case 1:
                languageData = _b.sent();
                if (!languageData) return [3, 4];
                return [4, put(addTranslationForLanguage(languageData, languageCode))];
            case 2:
                _b.sent();
                return [4, localStorage.setItem('locale', languageCode)];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2];
        }
    });
}
function actionWatcher() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, all([
                    takeLatest(INITIALIZE_I18N, safeSaga(initializeI18nHandler)),
                    takeLatest('@@localize/SET_ACTIVE_LANGUAGE', safeSaga(setActiveLanguageHandler))
                ])];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
export default function i18nSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, fork(actionWatcher)];
            case 1:
                _a.sent();
                return [2];
        }
    });
}
